<template>
    <div class="item-title">{{ title }}</div>
</template>

<script>
export default {
    name: 'SaleTitle',
    props: {
        title: {
            type: String,
            default: () => ''
        }
    } 
}
</script>

<style lang="less" scoped>
.item-title {
    font-size: 1.25vw;
    font-weight: bold;
    text-align: center;
    background-image: url('../img/img_title.png');
    height: 5.68421vh;
    background-size: 100% 100%;
    z-index: 99;
    /* 设置 position 为 relative 或 absolute，使 z-index 生效 */
    position: relative;
    width: 25vw;
    padding-top: 1vh;
    margin: 0 auto;
}
</style>